import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'confidence',
    label: 'Confidence',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
